export default __webpack_public_path__ + "static/media/logo.c07f8d1b.png";